import { tzAxios } from 'api/axios';
import { ConcertResponse, MatchResponse } from 'api/responseTypes';

export const getEventInfo = async (eventKey: string) =>
  (
    await tzAxios.get<MatchResponse & ConcertResponse>(
      `/ticket-zone/event/v2/event/${eventKey}/info`,
    )
  ).data;
